var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg0IconFillCheckCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1CC5BC"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.295 9.605l-4.568 6c-.188.247-.479.393-.789.395h-.007c-.307 0-.597-.142-.787-.383l-2.432-3.108c-.34-.434-.264-1.063.171-1.402.434-.341 1.064-.265 1.404.17l1.633 2.087 3.784-4.97c.334-.439.961-.524 1.402-.19.44.335.524.962.19 1.401M12 2.001C6.477 2 2 6.477 2 12c0 5.522 4.477 10 10 10s10-4.479 10-10c0-5.523-4.477-10-10-10",
    transform: "translate(-144 -1833) translate(120 1497) translate(0 320) translate(24 16)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0IconFillCheckCircleFill);
export default __webpack_public_path__ + "static/media/0-icon-fill-check-circle-fill.0c368664.svg";
export { ForwardRef as ReactComponent };